import Header from './components/Header';
import Footer from './components/Footer';
import About from './pages/About';
import NotFound from './pages/NotFound';
import {Route,Routes,BrowserRouter as Router,useNavigate, Navigate} from 'react-router-dom';
import {useState,useEffect} from 'react'
import api from './api/login';
import LoginUI from './pages/LoginUI';
import LogOutUI from './pages/LogOutUI';
import ProtectedRoute from './ProtectedRoute';
import Spinner from 'react-bootstrap/Spinner';



import MoreOptions from './pages/MoreOptions';


import NavAdmin from './components/NavAdmin';
import NavStudent from './components/NavStudent';
import UserNav from './components/UserNav';
import HomeAdmin from './pages/HomeAdmin';
import HomeStudent from './pages/HomeStudent';

import MasterCourse from './pages/MasterCourse';

import MarksEntry from './pages/MarksEntry';
import MarksEntryForm from './pages/MarksEntryForm';

import GradeEntry from './pages/GradeEntry';
import GradeEntryForm from './pages/GradeEntryForm';

import ResultDeclaration from './pages/ResultDeclaration';
import ResultDeclarationForm from './pages/ResultDeclarationForm';
import EditStudentDetails from './pages/EditStudentDetails';

import MarksEntryBatches from './pages/MarksEntryBatches';
import GradeEntryBatches from './pages/GradeEntryBatches';

import SubmittedGrades from './pages/SubmittedGrades';
import SubmittedGradeBatches from './pages/SubmittedGradeBatches';
import SubmittedGradeForm from './pages/SubmittedGradeForm';

import ConvocationCertificate from './pages/ConvocationCertificate';
import FourthConvocation from './pages/FourthConvocation';
import RunningTranscript from './pages/RunningTranscript';
import MeritList from './pages/MeritList';
import CompletionList from './pages/CompletionList';
import AccessDenied from './pages/AccessDenied';
import ProvisionalCertificate from './pages/ProvisionalCertificate';

import AcceptConvocationRequest from './pages/AcceptConvocationRequest';
import CourseStudentList from './pages/CourseStudentList';
import ManageUser from './pages/ManageUser';
import AddNewUser from './pages/AddNewUser';
import EditUser from './pages/EditUser';
import ChangePassword from './pages/ChangePassword';
import ViewStudentHistory from './pages/ViewStudentHistory';

function App() {    
  const [isAuthenticated,setIsAuthenticated]=useState(false); 
  const [isAppLoaded,setIsAppLoaded]=useState(true); 
  const [refreshFailed,setRefreshFailed]=useState(true);
  const [accessToken,setAccessToken]=useState(''); 
  const [loginType,setLoginType]=useState('');

  

      const [allowedPages,setAllowedPages]=useState([]);
      const [fullName,setFullName]=useState('');

            


    const sessions=[
      '2026-MAY',
  '2025-DECEMBER',
        '2025-MAY',
  '2024-DECEMBER',
  '2024-MAY',
  '2023-DECEMBER',
  '2023-MAY',
  '2022-DECEMBER',
  '2022-MAY',
  '2021-DECEMBER',
  '2021-MAY',
  '2020-DECEMBER'
      ];
      const levels=["UG","PG","PHD","PGD",'MTT'];
      const semesters=[1,2,3,4,5,6];

     const pageOptions = [ 
   "master_course",
  "edit_student_profile",
   "marks_entry",
  "grade_computation",
  "manage_submitted_grades",
  "course_student_list",

    "result_declaration",
       "merit_list",
       "completion_list",
        "print_transcript",
        "print_provisonal_pass_certificate",
  "process_convocation_request",
  "print_convocation_certificate",  
 "manage_fourth_convocation_data",
 "view_student_history"
];

      
      const [marksEntrySession,setMarksEntrySession]=useState('');
   const [gradeEntrySession,setGradeEntrySession]=useState('');
    const [resultEntrySession,setResultEntrySession]=useState('');
     const [submittedGradeSession,setSubmittedGradeSession]=useState('');

        const [marksEntryLevel,setMarksEntryLevel]=useState('');
          const [marksEntrySem,setMarksEntrySem]=useState('');
              const [marksEntrySub,setMarksEntrySub]=useState('');

               const [gradeEntryLevel,setGradeEntryLevel]=useState('');
          const [gradeEntrySem,setGradeEntrySem]=useState('');
              const [gradeEntrySub,setGradeEntrySub]=useState('');

               const [submittedGradeLevel,setSubmittedGradeLevel]=useState('');
          const [submittedGradeSem,setSubmittedGradeSem]=useState('');
              const [submittedGradeSub,setSubmittedGradeSub]=useState('');



  useEffect(()=>{
    const fetchAT=async ()=>{
          try{
            const config = { withCredentials: true };
            const x=await api.get('/getAccessToken',config);      
             
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];

             setAllowedPages(x['data']['allowedPages']); 

setFullName(x['data']['userFullName']);
            setAccessToken(nat);    
            setLoginType(lt);     
            setIsAuthenticated(true);   
            setRefreshFailed(false); 
            }
            catch(err)
            {
              //alert(err);
              setAccessToken('');   
              setLoginType('');   
              setIsAuthenticated(false);  
              setRefreshFailed(true);              
            }
            finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
    fetchAT();
  },[refreshFailed]);
  return (   
    <Router>
      <div className="App">
      {<Header></Header>}
        { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="admin")&& <NavAdmin
          />}
         { (isAppLoaded)&&!refreshFailed &&(loginType.toLowerCase()==="student")&& <NavStudent
          />} 
          
          { (isAppLoaded)&&refreshFailed&& <UserNav
          />
          }

        { (isAppLoaded) &&!refreshFailed &&(loginType.toLowerCase()==="admin")&&
          <>
          <Routes>
             <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                <Route  path='/' element={<HomeAdmin                        
                         allowedPages={allowedPages}
                         fullName={fullName}
                          />}>            
                </Route> 
                <Route  path='/changepassword' element={<ChangePassword                        
                           accessToken={accessToken} 
                           setAccessToken={setAccessToken}
                           setRefreshFailed={setRefreshFailed}
                           appUserName={setFullName}
                          />}>            
                </Route>

                <Route path='/masterCourse' element={<MasterCourse
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route>    
                <Route path='/marksentry' element={<MarksEntry
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          marksEntrySession={marksEntrySession}
                          setMarksEntrySession={setMarksEntrySession}
                          sessions={sessions}
                          levels={levels}
                          semesters={semesters}
                          marksEntryLevel={marksEntryLevel}
                          setMarksEntryLevel={setMarksEntryLevel}
                          marksEntrySem={marksEntrySem}
                          setMarksEntrySem={setMarksEntrySem}
                          marksEntrySub={marksEntrySub}
                          setMarksEntrySub={setMarksEntrySub}
                          />}> 
                </Route>  
                <Route path='/gradeComputation' element={<GradeEntry
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          gradeEntrySession={gradeEntrySession}
                          setGradeEntrySession={setGradeEntrySession}
                          sessions={sessions}

                            levels={levels}
                          semesters={semesters}
                          marksEntryLevel={gradeEntryLevel}
                          setMarksEntryLevel={setGradeEntryLevel}
                          marksEntrySem={gradeEntrySem}
                          setMarksEntrySem={setGradeEntrySem}
                          marksEntrySub={gradeEntrySub}
                          setMarksEntrySub={setGradeEntrySub}


                          />}> 
                </Route> 


                <Route path='/submittedgradecourses' element={<SubmittedGrades
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}

                          gradeEntrySession={submittedGradeSession}
                          setGradeEntrySession={setSubmittedGradeSession}
                          sessions={sessions}

                            levels={levels}
                          semesters={semesters}
                          marksEntryLevel={submittedGradeLevel}
                          setMarksEntryLevel={setSubmittedGradeLevel}
                          marksEntrySem={submittedGradeSem}
                          setMarksEntrySem={setSubmittedGradeSem}
                          marksEntrySub={submittedGradeSub}
                          setMarksEntrySub={setSubmittedGradeSub}


                          />}> 
                </Route> 

             <Route path='/gradeentrybatches/:courseCode/:session' element={<GradeEntryBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route> 

                 <Route path='/submittedGradeBatches/:courseCode/:session' element={<SubmittedGradeBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route> 
                

                <Route path="/gradeentryform/:batch/:session/:courseCode" element={<GradeEntryForm
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} /> 

                <Route path="/submittedgradeform/:batch/:session/:courseCode" element={<SubmittedGradeForm
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} /> 


                  <Route path='/marksentrybatches/:courseCode/:session' element={<MarksEntryBatches
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route> 

                <Route path='/marksentryform/:batch/:session/:courseCode' element={<MarksEntryForm
                          accessToken={accessToken} 
                          setAccessToken={setAccessToken}
                          setRefreshFailed={setRefreshFailed}
                          />}> 
                </Route>     

              <Route path="/resultdeclaration" element={<ResultDeclaration
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                resultEntrySession={resultEntrySession}
                setResultEntrySession={setResultEntrySession}
                sessions={sessions}
                />} />   

<             Route path="/resultdeclarationform/:batch/:session/:semester" element={<ResultDeclarationForm
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />   


   <Route path="/editstudentname" element={<EditStudentDetails
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />   

                <Route path="/convocationcertificate" element={<ConvocationCertificate
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />   
                <Route path="/fourthconvocationbulk" element={<FourthConvocation
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />   

                   <Route path="/provisonalcertificate" element={<ProvisionalCertificate
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />   

                 <Route path="/runningtranscript" element={<RunningTranscript
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                sessions={sessions}
                />} />
                 <Route path="/meritlist" element={<MeritList
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                sessions={sessions}
                />} /> 
                 <Route path="/completionlist" element={<CompletionList
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                sessions={sessions}
                />} />  
                <Route path="/acceptconvocationrequest" element={<AcceptConvocationRequest
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />   

                   <Route path="/coursestudentlist" element={<CourseStudentList
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />   
                 <Route path="/manageuser" element={<ManageUser
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                />} />  
                 <Route path="/addNewUser" element={<AddNewUser
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                pageOptions={pageOptions}
                />} />  
                <Route path="/userdetails/:user_name" element={<EditUser
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                pageOptions={pageOptions}
                />} />  
                <Route path="/viewstudenthistory" element={<ViewStudentHistory
                accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed}
                sessions={sessions}
                />} />

                <Route path='/moreoptions' element={<MoreOptions
                          />}> 
                </Route>
                
                
            </Route>
         
        
            <Route  path='/about' element={<About></About>}></Route>
             <Route  path='/accessdenied' element={<AccessDenied></AccessDenied>}></Route>
            <Route path='*' element={<NotFound></NotFound>}></Route>

            <Route  path='/login' element={!isAuthenticated? <LoginUI
                  setRefreshFailed={setRefreshFailed} setGlobalLoginType={setLoginType} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
            </Route>
            <Route  path='/logout' element={isAuthenticated? <LogOutUI
            setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setLoginType={setLoginType} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
            </Route>
          </Routes>
          </>
        }
      
      { (isAppLoaded) &&!refreshFailed &&(loginType.toLowerCase()==="student")&&
          <>
          <Routes>
             <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                <Route  path='/' element={<HomeStudent 
                          />}>            
                </Route>              
                <Route path='/moreoptions' element={<MoreOptions
                          />}> 
                </Route>
               
            </Route>
         
        
            <Route  path='/about' element={<About></About>}></Route>
            <Route path='*' element={<NotFound></NotFound>}></Route>

            <Route  path='/login' element={!isAuthenticated? <LoginUI
                  setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed}  setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>:<Navigate to="/" />}>            
            </Route>
            <Route  path='/logout' element={isAuthenticated? <LogOutUI
            setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>:<Navigate to="/Login" />}>            
            </Route>
          </Routes>
          </>
        }
      
      
      {
        !isAppLoaded &&
          <div className='spinnerovsetSeerlay'>
            <div className='spinnerbody'>
              <Spinner animation="border" variant="info" />
              <p>Please wait. It might take a few seconds.</p>
            </div>           
          </div>
      }
      {
       (isAppLoaded) && refreshFailed && 
        <>
       
        <Routes>
        <Route  path='/about' element={<About></About>}></Route>
          <Route path='*' element={ <LoginUI
                setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed} setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
                </Route>

          <Route  path='/login' element={ <LoginUI
                setGlobalLoginType={setLoginType} setRefreshFailed={setRefreshFailed}   setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated}/>}>            
          </Route>
          <Route  path='/logout' element={ <LogOutUI
          setAccessToken={setAccessToken} setIsAuthenticated={setIsAuthenticated} setRefreshFailed={setRefreshFailed}/>}>            
          </Route>
        </Routes>
        </>
      }

        <Footer></Footer>
      </div>
    </Router>
  );
}

export default App;
